import { useNavigate } from 'react-router-dom'
import clsx from 'clsx'

import { RouteDetails } from '@/types/routeDetails'
import { formatNumber } from '@/helpers/formatNumber'
import { getScoreStatus } from '@/components/Score/helpers/getScoreStatus'
import { useModal } from '@/components/Modal'
import { useWorkstationSelect } from '@/modules/Workstation/hooks/useWorkstationSelect'
import { DisruptionsList } from './DisruptionsList'

import styles from './Details.module.scss'
import { ROUTES } from '@/router'
import { useContext } from 'react'
import { RouteDetailsContext } from '../context'

export const Details = ({
    ewt,
    variance,
    mileageLossPercentage,
    curtailmentCount,
    disruptionCount,
    expected,
    actual,
    disruptions,
    mps,
}: RouteDetails) => {
    const variant = getScoreStatus({ mps, value: ewt, ewt, variance })
    const { handleWorkstationChange } = useWorkstationSelect()
    const { closeModal } = useModal()
    const navigate = useNavigate()
    const { workstationNumber, readOnly } = useContext(RouteDetailsContext)

    const openVehicleAllocation = () => {
        handleWorkstationChange(workstationNumber)

        closeModal()

        navigate(ROUTES.VEHICLE_ALLOCATION)
    }

    if (readOnly && disruptions.length === 0) {
        return null
    }

    return (
        <div className={styles.root}>
            {!readOnly && (
                <div className={styles.detailsList}>
                    <div className={styles.detailsItem}>
                        <p className={styles.detailsLabel}>MPS</p>
                        <p className={styles.detailsValue}>{formatNumber(mps, true)}</p>
                    </div>
                    <div className={clsx(styles.detailsItem, styles[variant])}>
                        <p className={styles.detailsLabel}>EWT</p>
                        <p className={styles.detailsValue}>{formatNumber(ewt, true)}</p>
                    </div>
                    <div className={styles.detailsItem}>
                        <p className={styles.detailsLabel}>Var</p>
                        <p className={styles.detailsValue}>{formatNumber(variance, true)}</p>
                    </div>
                    <div className={styles.detailsItem}>
                        <p className={styles.detailsLabel}>Miles lost</p>
                        <p className={styles.detailsValue}>{formatNumber(mileageLossPercentage, true)}%</p>
                    </div>
                    <div className={styles.detailsItem}>
                        <p className={styles.detailsLabel}>Curtailments</p>
                        <p className={styles.detailsValue}>{formatNumber(curtailmentCount, true)}</p>
                    </div>
                    <div className={clsx(styles.detailsItem, styles.disruptionItem)}>
                        <p className={styles.detailsLabel}>Disruptions</p>
                        <p className={styles.detailsValue}>{formatNumber(disruptionCount, true)}</p>
                    </div>
                    <div className={styles.detailsItem} onClick={openVehicleAllocation}>
                        <p className={styles.detailsLabel}>Expected</p>
                        <p className={styles.detailsValue}>{formatNumber(expected, true)}</p>
                    </div>
                    <div className={styles.detailsItem} onClick={openVehicleAllocation}>
                        <p className={styles.detailsLabel}>Actual</p>
                        <p className={styles.detailsValue}>{formatNumber(actual, true)}</p>
                    </div>
                </div>
            )}
            <DisruptionsList disruptions={disruptions} />
        </div>
    )
}
